"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomaBotInfo = void 0;
const vue_1 = require("vue");
const TagCount_1 = require("../TagCount");
exports.AutomaBotInfo = vue_1.default.component('AutomaBotInfo', {
    props: {
        player: {
            type: Object,
        },
    },
    components: {
        'tag-count': TagCount_1.TagCount,
    },
    template: `
    <div class="player-info">
        <div class="player-info-top">
            <div class="name-and-icon bot_translucent_bg_color">
                <div class="player-info-name">Bot</div>
            </div>

            <div class="player-corp bot_translucent_bg_color">{{ this.player.automaBotCorporation.name }}</div>
        </div>
        <div class="player-info-bottom bot_translucent_bg_color">
            <div class="player-tags">
                <div class="player-tags-main">
                    <tag-count :tag="'vp'" :count="this.player.automaBotVictoryPointsBreakdown.total" :size="'big'" :type="'main'" />
                    <tag-count :tag="'tr'" :count="this.player.automaBotVictoryPointsBreakdown.terraformRating" :size="'big'" :type="'main'"/>
                </div>
            </div>
        </div>
    </div>
  `,
});
//# sourceMappingURL=AutomaBotInfo.js.map